import styled from "styled-components"

export const Line = styled.div`
  margin: 10px 0;
  width: 93px;
  opacity: 0.7;
  border: 1px solid #e8f2ee;
`
